export default __webpack_public_path__ + "static/feature-flexible-delivery-3c41b035158b1b11d4129ad1279f1d57.webp";